import { Dispatch } from 'redux'
import { ISIC_ERROR, ISIC_LOADED, ISIC_LOADING } from '../slices/isicSlice'
import { NeoniApi } from '../../lib/api'
import { getApiErrorMessage } from '../../lib/utils'

export const getIsicCodes = (api: NeoniApi) => async (dispatch: Dispatch) => {
	dispatch({
		type: ISIC_LOADING,
	})

	try {
		const body = await api.get(`supplier_industry_codes`)

		if (body.success === true) {
			// Successfully fetched purchases
			dispatch({
				type: ISIC_LOADED,
				payload: body.data.supplierIndustryCodes,
			})
		} else {
			// Error
			dispatch({
				type: ISIC_ERROR,
				payload: getApiErrorMessage({ body }, 'Could not load ISIC codes. Please try again.'),
			})
		}
	} catch (error) {
		dispatch({
			type: ISIC_ERROR,
			payload: getApiErrorMessage(error, 'Could not load ISIC codes. Please try again.'),
		})
	}
}
